// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.MainContentRoleSetup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import { Tabs, Tab } from 'share/components/controls/Izenda.Tab';
import Permissions from 'modules/Settings/PermissionTab/Izenda.Permissions';
import DataModelAccess from './DataModelAccess/Izenda.DataModelAccess';
import PermissionSummary from './PermissionSummary/Izenda.PermissionSummary';
import UsersRoleSetup from './Users/Izenda.UsersRoleSetup';
import { head } from 'lodash/fp';

@connect()
export default class MainContentRoleSetup extends Component {
  validationBeforeChangeTabs = () => {
    const { store, validation } = this.props;
    return validation.validate().then(success => {
      if (success) {
        return store.validateAccesses().then(result => {
          if (result.success === false) {
            return validation.updateErrors(result.messages);
          } else {
            return Promise.resolve(true);
          }
        });
      }
    });
  };

  render() {
    const {
      store,
      readOnly,
      localization,
      authorization,
      authorizationConstants: { PERMISSION_KEY }
    } = this.props;
    const dataModelAccessPrivilege = authorization.checkPrivileges([PERMISSION_KEY.RoleSetupDataModelAccessValue]);
    const permissionsPrivilege = authorization.checkPrivileges([PERMISSION_KEY.RoleSetupPermissionsValue]);
    const userRoleAssociation = authorization.checkPrivileges([PERMISSION_KEY.UserSetupUserRoleAssociationValue]);
    const tabs = [];

    dataModelAccessPrivilege &&
      tabs.push(
        <Tab
          key='dataModelAccess'
          title={localization.getText('ROLE_SETUP_DATA_MODEL_ACCESS')}
          tabKey='dataModelAccess'
          className='u_fullSize'
        >
          <DataModelAccess dataModelAccess={store.dataModelAccess} readOnly={readOnly} store={store} />
        </Tab>
      );

    permissionsPrivilege &&
      tabs.push(
        <Tab key='permissions' title={localization.getText('COMMON_LABEL_PERMISSIONS')} tabKey='permissions'>
          <Permissions
            roleDetail={store.roleDetail}
            permissionStore={store.permissionStore}
            accessStore={store.accessStore}
            readOnly={readOnly}
          />
        </Tab>
      );

    userRoleAssociation &&
      tabs.push(
        <Tab key='users' title={localization.getText('ROLE_SETUP_USERS')} tabKey='users' className='u_fullSize'>
          <UsersRoleSetup store={store.usersRoleSetupStore} readOnly={readOnly} />
        </Tab>
      );

    tabs.push(
      <Tab
        key='permissionSummary'
        title={localization.getText('ROLE_SETUP_PERMISSION_SUMMARY')}
        tabKey='permissionSummary'
      >
        <PermissionSummary store={store} />
      </Tab>
    );

    const activeTabKey = head(tabs).props.tabKey;

    return (
      <div className='izenda-Wrapper-content u_marginLeftRight izenda-Role-content u-bgWhite'>
        <Tabs activeTabKey={activeTabKey} canChangeTab={this.validationBeforeChangeTabs}>
          {tabs}
        </Tabs>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/Izenda.MainContentRoleSetup.js